jQuery(document).ready(function ($) {
  // Slick carousel initialization
  var $carousel = $('.mb_reference-carousel .carousel-wrapper');
  $carousel.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    appendArrows: $('.carousel-arrows'),
    prevArrow:"<button type='button' class='slick-arrow slick-arrow--prev'><i class='icon icon-chevron-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-arrow slick-arrow--next'><i class='icon icon-chevron-right' aria-hidden='true'></i></button>",
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
